import acs from '@mos-utils/acs';

let subscriptions = [];
let unsubscribeACS;

const messageKey = `message.ACSBroadcast.common`;
const onStorage = ev => {
  if (ev.key !== messageKey) {
    return;
  }

  try {
    const message = JSON.parse(ev.newValue) || {};

    if (message.type) {
      acs.send({
        ...message,
        fromBroadcast: true
      });
    }
  } catch (e) {
    console.error(e);
  }
};

const ACSBroadcast = {
  init() {
    const handleSubscription = oneMessage => {
      subscriptions.forEach(onMessage => {
        if (typeof onMessage === 'function') {
          onMessage(oneMessage);
        }
      });
    };

    if (unsubscribeACS) {
      unsubscribeACS();
    }

    unsubscribeACS = acs.subscribe(message => {
      const cast = oneMessage => {
        localStorage.setItem(messageKey, JSON.stringify(oneMessage));
        localStorage.removeItem(messageKey);
      };

      if (Array.isArray(message)) {
        // логика Event Sourcing
        message.forEach(oneMessage => {
          handleSubscription(oneMessage);

          if (!oneMessage.fromBroadcast) {
            cast(oneMessage);
          }
        });
      } else {
        // логика обработки новых сообщений
        handleSubscription(message);

        if (!message.fromBroadcast) {
          cast(message);
        }
      }
    });

    window.removeEventListener('storage', onStorage);
    window.addEventListener('storage', onStorage);
  },

  subscribe(onMessage) {
    if (!onMessage || typeof onMessage !== 'function') {
      return;
    }

    subscriptions.push(onMessage);
  },

  unsubscribe(onMessage) {
    if (typeof onMessage !== 'function') {
      return;
    }

    subscriptions.forEach(handler => {
      if (handler === onMessage) {
        const index = subscriptions.indexOf(onMessage);

        subscriptions.splice(index, 1);
      }
    });
  },

  off() {
    subscriptions = [];

    if (unsubscribeACS) {
      unsubscribeACS();
    }
  }
};

export default ACSBroadcast;
